<script>
    import { Row, Col } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    import FormAlerts from '../FormAlerts.svelte'
    import InputText from '@fno/component2/form/InputText.svelte'
    import FormSavingButtons from '../FormSavingButtons.svelte'

    export let context
    export let saving

    const dispatch = createEventDispatcher()

    $: {
        // if they are adding affiliations for the first time
        // we need to enable them in the portal and set the default order

        const hasAffiliations = !!Object.keys(context.form.affiliations.attributes.affiliations).find(
            (key) => context.form.affiliations.attributes.affiliations[key] !== ''
        )

        context.form.school.attributes.featuresEnabledInApp.affiliations = hasAffiliations

        if (!hasAffiliations) {
            context.form.affiliations.attributes.order = Object.keys(context.view.affiliationSchema)
        }

        dispatch('change', {
            formKey: 'school',
            keypath: 'attributes.featuresEnabledInApp.affiliations',
            value: hasAffiliations,
            context
        })
    }
</script>

<style>
    iframe {
        margin: 50px 0;
    }
</style>

<h1>Affiliations</h1>

<p>Please watch the short instructional video below about affiliations.</p>

<Row>
    <Col class="text-center">
        <iframe
            title="embedded video about app naming"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/OOpw0YbX654"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
    </Col>
</Row>

<h2>Add Your Affiliations</h2>
<p>
    Please enter a custom affiliation name in the correct input. Note: not all affiliations have to be used. If no text
    is entered into the field, it will be hidden in the application.
</p>

{#each Object.keys(context.view.affiliationSchema) as affiliation}
    <Row class="mb-3">
        <Col xs="6">
            <!-- We don’t allow custom text for Reward Users at this time. -->
            {#if affiliation !== 'reward_users'}
                <InputText
                    placeholder="Hidden unless supplied"
                    label={context.view.affiliationSchema[affiliation].label}
                    {context}
                    formKey="affiliations"
                    keypath={`attributes.affiliations.${affiliation}`}
                    bind:value={context.form.affiliations.attributes.affiliations[affiliation]}
                    on:change
                />
            {/if}
        </Col>
    </Row>
{/each}

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
